import React, { useEffect, useState } from "react";
import { open_api_with_cookies } from "../../../Utils/network";
import TableCard from "../../../components/Card/TableCard";
import FilterChip from "../../../components/Chip/FilterChip";
import Chips from "../../../components/Chip/Chips";
import DateRangeChip from "../../../components/Chip/DateRangeChip";
import SearchBar from "../../../components/Search/SearchBar";
import "../AllTransactions/AllTransactions.css";
import Cookies from "js-cookie";
const XLSX = require("xlsx");

export default function AllTransactions() {
  const [selectedOption, setSelectedOption] = useState("All");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [options, setOptions] = useState(["All", "Workshop", "Session"]);
  const [isLoading, setLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("All");
  const [statusId, setStatusId] = useState(0);

  const status = ["All", "Paid", "Failed"];

  const columns = [
    { header: "Customer Name", accessor: "customer_name" },
    { header: "Product", accessor: "type" },
    { header: "Product title", accessor: "product_title" },
    { header: "Batch", accessor: "batch_name" },
    { header: "Purchased Date", accessor: "created_at" },
    { header: "Purchased time", accessor: "created_time" },
    { header: "Paid", accessor: "total_amt" },
    { header: "Expert Earning", accessor: "expert_earning" },
    { header: "Coupon used", accessor: "coupon_code" },
    { header: "Status", accessor: "payment_status" },
  ];

  const createDateString = (date) => {
    const required_date = new Date(date);
    const month =
      required_date.getMonth() + 1 < 10
        ? `0${required_date.getMonth() + 1}`
        : required_date.getMonth() + 1;
    const day =
      required_date.getDate() < 10
        ? `0${required_date.getDate()}`
        : required_date.getDate();
    const date_string = `${required_date.getFullYear()}-${month}-${day}`;
    return date_string;
  };
  const id = Cookies.get("expertID");
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handleSelect = (option) => {
    setSelectedOption(option);
    setCurrentPage(1);
  };

  const handleStatus = (event) => {
    if (event === "Paid") {
      setPaymentStatus("Paid");
      setStatusId(3);
    } else if (event === "Failed") {
      setPaymentStatus("Failed");
      setStatusId(4);
    } else {
      setPaymentStatus("All");
      setStatusId(0);
    }
    console.log(event);
  };

  const handleDateChange = (start, end) => {
    const updatedStartDate = start !== null ? createDateString(start) : null;
    const updatedEndDate = end !== null ? createDateString(end) : null;

    setStartDate(updatedStartDate);
    setEndDate(updatedEndDate);
    setCurrentPage(1);
  };

  const isValidResponse = (result) => {
    if (
      (result.status === 200 || result.status === 201) &&
      result.data !== null &&
      result.data !== undefined
    ) {
      setTableData(result.data);
      setTotalPages(Math.ceil(result.data.length / 10));
      setTotalEntries(result.data.length);
    }
  };

  const filters = async () => {
    if (selectedOption === "All") {
      const result = await open_api_with_cookies.get(
        `/dashboard/revenue/all-transcations/?expert_id=${id}${
          statusId === 0 ? "" : `&payment_status=${statusId}`
        }&start_date=${startDate !== null ? startDate : ""}&end_date=${
          endDate !== null ? endDate : ""
        }&search=${searchQuery}`
      );
      isValidResponse(result);
      console.log(tableData);
    } else {
      const result = await open_api_with_cookies.get(
        `/dashboard/revenue/all-transcations/?expert_id=${id}&product_type=${selectedOption}${
          statusId === 0 ? "" : `&payment_status=${statusId}`
        }&start_date=${startDate !== null ? startDate : ""}&end_date=${
          endDate !== null ? endDate : ""
        }&search=${searchQuery}`
      );
      isValidResponse(result);
    }
  };

  const generateExport = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const date = new Date();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      `Transactions Data ${date.getDate()}-${
        date.getMonth() + 1
      }-${date.getFullYear()}`
    );
    XLSX.writeFile(
      workbook,
      `Transactions ${date.getDate()}-${
        date.getMonth() + 1
      }-${date.getFullYear()}.xlsx`
    );
  };

  useEffect(() => {
    filters();
  }, [selectedOption, statusId, searchQuery, startDate, endDate]);

  return (
    <div className="revenue">
      <p className="subtitle">
        All Transactions
        <Chips
          color={"pink"}
          icon={""}
          text={"Export"}
          onClick={generateExport}
        ></Chips>
      </p>

      <div className="revenue-filters">
        <div className="filters-container">
          {/* <FilterChip
                        options={status}
                        selected={paymentStatus}
                        onSelect={handleStatus}
                    /> */}
          <FilterChip
            options={options}
            selected={selectedOption}
            onSelect={handleSelect}
          />
          <DateRangeChip
            label="Select Date Range"
            onDateChange={handleDateChange}
          />
        </div>
        <div className="search-container">
          <SearchBar onSearch={handleSearch} />
        </div>
      </div>
      <TableCard
        columns={columns}
        data={tableData}
        totalEntries={totalEntries}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        isClickable={false}
        loading={isLoading}
        isShowJoinButton={false}
        isRevenue={true}
      />
    </div>
  );
}
